/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalInfoRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
